import React from 'react';
import { Box, Container, Stack, Text, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="gray.50"
      color="gray.700"
      py={4}
      position="relative"
      bottom={0}
      width="100%"
      borderTop="1px"
      borderColor="gray.200"
    >
      <Container maxW="container.xl">
        <Stack
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify="space-between"
          align="center"
        >
          <Text>© {new Date().getFullYear()} Pragma Journal. All rights reserved.</Text>
          <Stack direction="row" spacing={6}>
            <Link as={RouterLink} to="/privacy" color="gray.600" _hover={{ color: 'blue.500' }}>
              Privacy Policy
            </Link>
            <Link as={RouterLink} to="/terms" color="gray.600" _hover={{ color: 'blue.500' }}>
              Terms of Service
            </Link>
            <Link as={RouterLink} to="/contact" color="gray.600" _hover={{ color: 'blue.500' }}>
              Contact Us
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
